var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7539 66.178L93.3474 45.0293H88.9414L72.7966 63.3924L59.9019 45.0293H45.0293L64.5287 72.7976L45.0293 94.9752H49.4356L66.4849 75.5832L80.1027 94.9752H94.9752L74.7528 66.178H74.7539ZM68.7189 73.0422L66.7432 70.2771L51.0233 48.275H57.7911L70.4773 66.0314L72.453 68.7965L88.9434 91.8772H82.1756L68.7189 73.0433V73.0422Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.4620a7ed237a6ff9d211a88f293fc790.svg";
export { ForwardRef as ReactComponent };